export interface AgentUploadLimitStrategy {
    getLimit(): Promise<number | undefined>
}

export const AgentUploadLimitStrategy = Symbol('AgentUploadLimitStrategy')
